/** « 87,5 % » : une mesure sur [0..1] en pourcentage ; « — » sans mesure. */
export function formatPercent(measure: number | null | undefined): string {
  return measure == null ? '—' : `${Math.round(measure * 1000) / 10} %`
}

/** « 17,4 / 20 » : un score brut sur son maximum ; `null` quand l'un manque ou est aberrant. */
export function formatScore(raw: number | null | undefined, max: number | null | undefined): string | null {
  if (raw == null || max == null) return null
  if (!Number.isFinite(raw) || !Number.isFinite(max)) return null
  if (Math.abs(raw) > 1_000_000 || Math.abs(max) > 1_000_000) return null
  const fmt = (n: number) => Number.parseFloat(n.toFixed(2)).toString()
  return `${fmt(raw)} / ${fmt(max)}`
}
